/**
 * Base64URL encode (RFC 4648 Section 5)
 * @param {Uint8Array} buffer - Buffer to encode
 * @returns {string} Base64URL encoded string
 */
export function base64URLEncode(buffer) {
	const base64 = btoa(String.fromCharCode(...buffer));
	return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/**
 * Base64URL encode a string (RFC 4648 Section 5)
 * @param {string} str - String to encode
 * @returns {string} Base64URL encoded string
 */
export function base64URLEncodeString(str) {
	const encoder = new TextEncoder();
	const buffer = encoder.encode(str);
	return base64URLEncode(buffer);
}

/**
 * Base64URL decode an encoded string (RFC 4648 Section 5)
 * @param {string} data - Base64URL encoded string
 * @returns {string} Decoded string
 */
export function base64URLDecode(data) {
	let base64 = data.replace(/-/g, '+').replace(/_/g, '/');
	while (base64.length % 4 > 0) {
		base64 += '=';
	}
	return atob(base64);
}
